import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseApp = initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_API_CONFIG));

export const firebaseAnalytics = getAnalytics();

export const getFbAuth = getAuth(firebaseApp);
const auth = getAuth();
auth.languageCode = "en";
export const messaging = getMessaging(firebaseApp);


export default firebaseApp;
